import { useContext, useMemo } from 'react';
import { HappeningsContext } from '../contexts/happeningsContext';
import { useFetchHappeningsData } from '../hooks/useFetchHappeningsData';
import { getEnvValueFor } from '../../../helpers/utils';
import { useParams } from 'react-router-dom';
import { DashboardEventsContext } from '../../../components/dashboardEvents';
import type { RootState } from '../../../state/store';
import { useSelector } from 'react-redux';

// variants = positive, neutral, negative
interface HappeningsProviderProps {
  children: React.ReactNode;
}

const HappeningsProvider = ({ children }: HappeningsProviderProps): JSX.Element => {
  const { demo_account: isDemoAccount } = useSelector(
    (state: RootState) => state.company.company_details
  );
  const refreshInterval = getEnvValueFor('HAPPENINGS_POLL_INTERVAL');

  const routeMatch = useParams();

  // Restrict data polling to d-level dashboards and not for demo accounts
  const enableDataPolling = useMemo(
    () => routeMatch.dashboard && !routeMatch.widget && !isDemoAccount,
    [routeMatch, isDemoAccount]
  );

  const { isLiveDashboard } = useContext(DashboardEventsContext);

  const { data } = useFetchHappeningsData({
    dashboard: routeMatch.dashboard,
    isLive: isLiveDashboard,
    refreshInterval:
      enableDataPolling && refreshInterval ? parseInt(refreshInterval) * 1000 : undefined
  });
  const eventsData = useMemo(() => data ?? [], [data]);

  return <HappeningsContext.Provider value={{ eventsData }}>{children}</HappeningsContext.Provider>;
};

export default HappeningsProvider;
